import './LocationInfo.scss';
import {faLocationDot} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Text from 'components/Text/Text';

interface Props {
  country: string;
  city: string;
}

const LocationInfo = ({country, city}: Props) => {
  return (
    <div className="location-info">
      <div className="location-info__icon">
        <FontAwesomeIcon icon={faLocationDot} />
      </div>
      <div className="location-info__location">
        <Text tag="span">
          {country}, &nbsp;{city}
        </Text>
      </div>
    </div>
  );
};

export default LocationInfo;
